import AddCircleIcon from "@mui/icons-material/AddCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CircleIcon from "@mui/icons-material/Circle";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Grid,
  Modal,
  styled,
  TableCell,
  tableCellClasses,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import {
  AccessUserRoleResponse,
  GetUserRolesResponse,
} from "../../../models/role.model";
import { AccessUserRole } from "../../../services/role.service";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#34495E",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  role: GetUserRolesResponse;
  setUserOfficeRoles: any;
  userOfficeRoles: GetUserRolesResponse[];
  userId: number;
}
const PermissionRoleTableRows = ({
  role,
  setUserOfficeRoles,
  userOfficeRoles,
  userId,
}: Props) => {
  const [isHovered, setHovered] = useState<{
    plusIcon: boolean;
    crossIcon: boolean;
    dotIcon: boolean;
  }>({
    plusIcon: false,
    crossIcon: false,
    dotIcon: false,
  });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [accessTypeServiceResponse, setAccessTypeServiceResponse] = useState<
    AccessUserRoleResponse
  >();

  const [accessTypeForDel, setAccessTypeForDel] = useState<"Allow" | "Deny">(
    "Deny"
  );

  const handleDeleteRole = () => {
    AccessUserRoleMutate({
      userId: userId,
      roleId: role.roleId,
      accessType: accessTypeForDel,
    });
    setOpenDeleteModal(false);
  };

  const { mutate: AccessUserRoleMutate } = useMutation(AccessUserRole, {
    onSuccess: (data: AccessUserRoleResponse) => {
      if (data) {
        // setAccessTypeServiceResponse(data);

        if (data.isRemoved) {
          setUserOfficeRoles(
            userOfficeRoles.filter(
              (item) => item.userRoleId !== role.userRoleId
            )
          );
        } else {
          if (data.userRoleId !== null) {
            setUserOfficeRoles(
              userOfficeRoles.map((item) =>
                item.roleId === role.roleId
                  ? { ...item, accessType: "Deny" }
                  : item
              )
            );
          } else {
            setUserOfficeRoles(
              userOfficeRoles.map((item) =>
                item.roleId === role.roleId
                  ? { ...item, accessType: "Allow" }
                  : item
              )
            );
          }
        }
      }
    },
    onError: () => {},
  });

  return (
    <>
      <StyledTableRow>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.title}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.createDatePersian}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.creatorUserName}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.exclusivePermission ? "بله" : "خیر"}
          </p>
        </StyledTableCell>

        <StyledTableCell align="right" sx={{ borderTop: "none !important" }}>
          {role.exclusivePermission ? (
            role.accessType === "Allow" &&
            (!isHovered.plusIcon ? (
              <span
                style={{
                  textAlign: "center",
                  marginBottom: "-.5vh",
                }}
                onMouseEnter={() =>
                  setHovered({ ...isHovered, plusIcon: true })
                }
              >
                <AddCircleIcon
                  style={{
                    color: "#01AF43",
                    cursor: "pointer",
                    marginInline: "3px",
                  }}
                />
              </span>
            ) : (
              <span
                style={{
                  textAlign: "center",
                  marginBottom: "-.5vh",
                }}
                onMouseLeave={() =>
                  setHovered({ ...isHovered, plusIcon: false })
                }
              >
                <Tooltip arrow title="حذف نقش">
                  <DoDisturbIcon
                    onClick={() => {
                      setOpenDeleteModal(true);
                      setAccessTypeForDel("Deny");
                    }}
                    style={{
                      color: "#9AAFC4",
                      cursor: "pointer",
                      marginInline: "3px",
                    }}
                  />
                </Tooltip>
              </span>
            ))
          ) : role.accessType === "Allow" ? (
            !isHovered.dotIcon ? (
              <span
                style={{
                  textAlign: "center",
                  marginBottom: "-.5vh",
                }}
                onMouseEnter={() => setHovered({ ...isHovered, dotIcon: true })}
              >
                <CircleIcon
                  style={{
                    color: "#01AF43",
                    cursor: "pointer",
                    marginInline: "3px",
                  }}
                />
              </span>
            ) : (
              <span
                style={{
                  textAlign: "center",
                  marginBottom: "-.5vh",
                }}
                onMouseLeave={() =>
                  setHovered({ ...isHovered, dotIcon: false })
                }
                onClick={() => {
                  setOpenDeleteModal(true);
                  setAccessTypeForDel("Deny");
                }}
              >
                <Tooltip arrow title="حذف نقش">
                  <DoDisturbIcon
                    style={{
                      color: "#9AAFC4",
                      cursor: "pointer",
                      marginInline: "3px",
                    }}
                  />
                </Tooltip>
              </span>
            )
          ) : !isHovered.crossIcon ? (
            <span
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
              }}
              onMouseEnter={() => setHovered({ ...isHovered, crossIcon: true })}
            >
              <CancelIcon
                style={{
                  color: "#E6123D",
                  cursor: "pointer",
                  marginInline: "3px",
                }}
              />
            </span>
          ) : (
            <span
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
              }}
              onClick={() => {
                setOpenDeleteModal(true);
                setAccessTypeForDel("Allow");
              }}
              onMouseLeave={() =>
                setHovered({ ...isHovered, crossIcon: false })
              }
            >
              <Tooltip arrow title="بازگرداندن نقش">
                <RefreshIcon
                  style={{
                    color: "#9AAFC4",
                    cursor: "pointer",
                    marginInline: "3px",
                  }}
                />
              </Tooltip>
            </span>
          )}
        </StyledTableCell>
      </StyledTableRow>
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            {accessTypeForDel === "Deny" ? (
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                marginY={"3rem"}
                fontSize={"14px"}
              >
                آیا از حذف نقش سازمانی{" "}
                <span style={{ color: "#E6123D", fontWeight: "bold" }}>
                  "{role.title}"
                </span>{" "}
                <br />
                اطمینان دارید؟
              </Typography>
            ) : (
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                marginY={"3rem"}
                fontSize={"14px"}
              >
                آیا از بازگرداندن نقش سازمانی{" "}
                <span style={{ color: "#01AF43", fontWeight: "bold" }}>
                  "{role.title}"
                </span>
                <br />
                اطمینان دارید؟
              </Typography>
            )}
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor:
                    accessTypeForDel === "Deny" ? "#E6123D" : "#01AF43",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={handleDeleteRole}
                >
                  بله
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  خیر
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default PermissionRoleTableRows;
